import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';

interface Props{
    setEnableModal: any,
    is_open: boolean,
    router: any
}

const EraseSRListAlert = (props: Props) => {

    const close = () => {
        props.setEnableModal(false);
        return false
    }

    const proceed = () => {
        close();
        props.router.reload()
    }

    const alertTitle = "Attention!"
    const alertText = "Would you like to discard the selected SRs and start over?"

    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            <div className={styles.selfserve_add_device}>
                <h5 className={styles.selfserve_add_device__title}>{alertTitle}</h5>
                <div className={styles.selfserve_add_device__text}>
                    <p>{alertText}</p>
                </div>
                <div className={`${commonStyles.button_actions_sticky} ${styles.add_device_buttons}`} data-varient='non-sticky'>
                    <Button
                        onClick={close}
                        text="Cancel"
                        variant="secondary"
                        className={commonStyles.cart_btn}
                        style={{ 'fontSize': '14px' }}
                    />
                    <Button
                        text="Proceed"
                        onClick={proceed}
                        className={commonStyles.cart_btn}
                        style={{ 'fontSize': '14px' }}
                    />
                </div>
            </div>
        </UIModal>
    )
}

export default EraseSRListAlert
